import routerName from './router-name';
import sidebarMenu from './sidebar-menu';
const en = {
    routerName,
    sidebarMenu
};
export default en;
